'use client';

import { getRelativeAssetPath } from '@/utils/base-path';
import { ImageProps as NextImageProps } from 'next/image';

interface ImageProps extends NextImageProps {
    forceSrc?: boolean;
}

const ORIGIN =
    process.env.NEXT_PUBLIC_ASSET_ORIGIN ?? 'https://image-nations-long-film-festivale.fly.dev';

const Image = (props: ImageProps) => {
    const { src, fill, forceSrc, ...rest } = props;

    const isRemote = (u: string) =>
        /^(?:https?:)?\/\//.test(u) || u.startsWith('data:') || u.startsWith('mailto:');
    const isDevelopment = process.env.NODE_ENV === 'development';

    const resolveSrc = (value: ImageProps['src']): string => {
        if (typeof value === 'string') {
            return value;
        }

        if (typeof value === 'object' && value !== null && 'src' in value) {
            return value.src as string;
        }

        return String(value);
    };

    const normalizedSrc = resolveSrc(src);

    if (forceSrc || isRemote(normalizedSrc)) {
        const directSrc = isRemote(normalizedSrc)
            ? normalizedSrc
            : isDevelopment || !ORIGIN
              ? getRelativeAssetPath(normalizedSrc)
              : `${ORIGIN}${getRelativeAssetPath(normalizedSrc)}`;
        // eslint-disable-next-line @next/next/no-img-element, jsx-a11y/alt-text
        return <img src={directSrc} {...rest} />;
    }

    const localPath = getRelativeAssetPath(normalizedSrc);
    const imagePath = isDevelopment || !ORIGIN ? localPath : `${ORIGIN}${localPath}`;

    // eslint-disable-next-line @next/next/no-img-element, jsx-a11y/alt-text
    return <img src={imagePath} {...rest} />;
};

export default Image;
